import React from "react";
import { ModalFee } from "./Fee";
import { ModalCancelNotification } from "./CancelNotification";
import { ModalNoShowNotification } from "./NoShowNotification";
import { ModalConfirmCancel } from "./ConfirmCancel";
import { ModalConfirmNoShow } from "./ConfirmNoShow";
import { ModalCheckin } from "./Checkin";

function Modals() {
  const modals = [
    {
      id: "fees",
      component: ModalFee,
    },
    {
      id: "cancelNotification",
      component: ModalCancelNotification,
    },
    {
      id: "noShowNotification",
      component: ModalNoShowNotification,
    },
    {
      id: "confirmCancel",
      component: ModalConfirmCancel,
    },
    {
      id: "confirmNoShow",
      component: ModalConfirmNoShow,
    },
    {
      id: "checkin",
      component: ModalCheckin,
    },
  ];

  return (
    <>
      {modals.map((m) => (
        <m.component key={m.id} />
      ))}
    </>
  );
}

Modals.Fee = ModalFee;
Modals.CancelNotification = ModalCancelNotification;
Modals.NoShowNotification = ModalNoShowNotification;
Modals.ConfirmCancel = ModalConfirmCancel;
Modals.ConfirmNoShow = ModalConfirmNoShow;
Modals.Checkin = ModalCheckin;

export { Modals };
